export default "__VITE_ASSET__zy4rNwfO__"